export class DatePicker {
  constructor() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {
        let nowTemp = new Date();
        let now = new Date(nowTemp.getFullYear(), nowTemp.getMonth(), nowTemp.getDate(), 0, 0, 0, 0);

        element.fdatepicker({
          format: 'dd.mm.yyyy',
          language: 'es',

          onRender: function (date) {
            return date.valueOf() < now.valueOf() ? 'disabled' : '';
          },

          onSelect: function (date) {
            scope.event.date = date;
            scope.$apply();
          }

        });
      }
    }
  }
}
